<div class="grid-container" [ngClass]="'grid-container--' + numCards">
  <cm-person-card
    *ngFor="let person of persons.slice(first, first + numCards)"
    [variables]="variables"
    [person]="person"
    [actions]="actions"
    [actionsCallback]="actionsCallback"
  ></cm-person-card>
</div>

<button mat-icon-button (click)="prev()" [disabled]="first <= 0"><mat-icon>chevron_left</mat-icon></button>
<button mat-icon-button (click)="next()" [disabled]="first + numCards >= persons.length"><mat-icon>chevron_right</mat-icon></button>

<button mat-icon-button class="close-button" (click)="closeVisualizer()"><mat-icon>close</mat-icon></button>
